const _excluded = ["onCloseModal"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
import useUserSubscriptions from './hooks/useUserSubscriptions';
import SubscriptionsModalView from './SubscriptionsModalView';
/**
 * A SubscriptionsModal
 * A Subscriptions Modal allows to show messages about subscriptions of the user.
 */

const SubscriptionsModal = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      onCloseModal
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    subscriptions,
    error,
    isLoading,
    refetch
  } = useUserSubscriptions();
  return /*#__PURE__*/React.createElement(SubscriptionsModalView, _extends({
    onCloseModal: onCloseModal,
    error: error,
    ref: ref,
    subscriptions: subscriptions,
    isLoading: isLoading,
    refetch: refetch
  }, props));
});
SubscriptionsModal.displayName = 'SubscriptionsModal';
SubscriptionsModal.propTypes = {
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Close modal function */
  onCloseModal: PropTypes.func.isRequired,
  /** Styles applied to the root element */
  style: stylePropType
};
export default SubscriptionsModal;
//# sourceMappingURL=SubscriptionsModal.js.map